import { EmbedChannel } from '../channel'
import { getAuthorizationRequestUrl } from '../utils/getAuthorizeRequestUrl'

export const sendNewTokenOnRefreshToken = (
  channel: EmbedChannel,
  clientId: string,
  state: string | undefined | null,
  authBaseUrl: string,
) => {
  channel.subscribe('refresh-token', async () => {
    const { authCode, authUrl } = getAuthorizationRequestUrl(clientId, state, authBaseUrl)
    try {
      await fetch(authUrl)
    } catch (error) {
      throw new Error(error instanceof Error ? error.message : String(error))
    }
    channel.send('auth-code', { authCode })
  })
}
